export default __webpack_public_path__ + "static/logo_background-3aad640d4c8a98e84627be85ed3ae31c.png";